import autoBind from "auto-bind";
import { PostData } from "../posts/post.models";
import { randomNumber } from "./randomization";

export class DateRandomizer {
  protected currentOffset: number;
  protected index: number = 0;
  protected minimumGapMinutes: number;
  protected maximumGapMinutes: number;
  protected gapIncrement: number;

  constructor(
    minimumGapMinutes: number,
    maximumGapMinutes: number,
    gapIncrement?: number,
    startFrom?: number
  ) {
    this.currentOffset = startFrom ?? 0;
    this.minimumGapMinutes = minimumGapMinutes;
    this.maximumGapMinutes = maximumGapMinutes;
    this.gapIncrement = gapIncrement ?? 0;
    autoBind(this);
  }

  next(): number {
    const min = this.minimumGapMinutes;
    const max = this.maximumGapMinutes + this.gapIncrement * this.index;
    const offsetDelta = randomNumber(min, max);
    this.currentOffset += offsetDelta;
    this.index++;
    return this.currentOffset;
  }

  /**
   * Generate a list of date offsets (in minutes) prior to the current time.
   * List will be ordered from most recent to least recent.
   * @param num The number of dates to generate.
   */
  generateSequence(num: number): number[] {
    const sequence: number[] = [];

    for (let i = 0; i < num; i++) {
      sequence.push(this.next());
    }

    return sequence;
  }

  reset(start?: number) {
    this.currentOffset = start ?? 0;
    this.index = 0;
  }
}

export class CommentDateRandomizer extends DateRandomizer {
  private previousOffset: number = 0;
  constructor(post: PostData, numComments: number) {
    const min = 0;
    let max = 0;

    if (post.dateOffset != null) {
      max = post.dateOffset / numComments;
      // console.debug("max = ", post.dateOffset, "/", numComments, max);
    }

    super(min, max, max, 0);

    // console.debug(
    //   `comment_generator: initialized new comment generator ${min} ${max}, postdateoffset = ${post.dateOffset} numComments = ${numComments}`
    // );

    autoBind(this);
  }

  next(): number {
    const min = this.currentOffset;
    const max = this.maximumGapMinutes + this.gapIncrement * this.index;
    const offsetDelta = randomNumber(min, max);
    this.currentOffset = offsetDelta;
    this.index++;
    // console.debug(
    //   `comment_generator: choosing random date offset for comment between ${min} and ${max} -> ${offsetDelta}`
    // );
    return this.currentOffset;
  }
}
